<dashboardnav>
  <cradua-divestmentstatus
  [divestmentstatuss]="divestmentstatuss$ | async"
  (divestmentstatus)="onSubmitDivestmentStatus($event)"
  (deleteDivestmentStatusEvent)="onDeleteDivestmentStatus($event)"
  *ngIf="(isLoadingDivestmentStatus$ | async ) === false"
  >
</cradua-divestmentstatus>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingDivestmentStatus$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
